import {
  ACT_FETCH_REQUEST,
  ACT_FETCH_SUCCESS,
  ACT_FETCH_FAILURE,
  ACT_CLEAR
} from './actActions'

const INITIAL_STATE = {
  itens: [],
  total: 0,
  filtros: {
    dataInicial: '',
    dataFinal: ''
  },
  loading: false,
  loaded: false,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACT_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case ACT_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        itens: action.payload.itens,
        total: action.payload.total,
        filtros: action.payload.filtros
      }

    case ACT_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case ACT_CLEAR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}